import { Badge as _Badge, type BadgeProps, badgeClasses, styled } from "@mui/material"

const StyledBadge = styled(_Badge)(({ theme, color }) => ({
	color: color || theme.palette.blue[400],
	variants: [
		{
			props: { color: "warning" },
			style: {
				[`& .${badgeClasses.badge}`]: {
					backgroundColor: theme.palette.yellow[300],
				},
			},
		},
	],
}))

const StyledTextBadge = styled(StyledBadge)(({ theme }) => ({
	[`& .${badgeClasses.badge}`]: {
		right: `calc(-1 * ${theme.spacing(1.25)})`,
		top: 8,
		padding: "0 4px",
	},
	variants: [
		{
			props: { className: "text-xxs" },
			style: {
				[`& .${badgeClasses.badge}`]: {
					fontSize: theme.typography.fontSize * 0.6,
					top: 6,
					height: 15,
					borderRadius: 7.5,
					minWidth: 15,
				},
			},
		},
	],
}))

export function TextBadge(props: BadgeProps) {
	return <StyledTextBadge {...props} />
}
